import { render, staticRenderFns } from "./ItemDetailList.vue?vue&type=template&id=11ffd458&scoped=true"
import script from "./ItemDetailList.vue?vue&type=script&lang=js"
export * from "./ItemDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ffd458",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ffd458')) {
      api.createRecord('11ffd458', component.options)
    } else {
      api.reload('11ffd458', component.options)
    }
    module.hot.accept("./ItemDetailList.vue?vue&type=template&id=11ffd458&scoped=true", function () {
      api.rerender('11ffd458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/itemDetailPlugin/ItemDetailList.vue"
export default component.exports